import React, { useState } from 'react'
import InfoButton from '../../components/InfoButton'
import { ProSubscriptionInfoPopup } from '../../components/ProSubscriptionInfoPopup'
import { applyDiscountToPrice } from '../../util/priceCalculation'
import 'pages/Styles/ProSubscription.sass'

type ProTariff = {
    _id: string
    name: string
    period: string
    price: number
    discount?: number
}

type Props = {
    tariffs: ProTariff[]
    cart: any[]
    onAddToCart: (tariff: ProTariff) => void
}

function periodLabel(period: string): string {
    if (period === 'month') return '1 месяц'
    if (period === 'quarter') return '3 месяца'
    if (period === 'year') return '1 год'
    return period
}

function periodHint(period: string): string {
    if (period === 'month') return 'Оплата каждый месяц'
    if (period === 'quarter') return 'Оплата раз в 3 месяца'
    if (period === 'year') return 'Оплата раз в год'
    return 'Подписка с автопродлением'
}

function formatPriceRub(kopecks: number): string {
    return `${(kopecks / 100).toLocaleString('ru-RU')} ₽`
}

function ProSubscriptionSection({ tariffs, cart, onAddToCart }: Props) {
    const [showInfoPopup, setShowInfoPopup] = useState(false)

    function isInCart(tariffId: string) {
        return cart.some(item => item.type === 'pro_subscription' && item._id === tariffId)
    }

    function handleInfoClick(event: React.MouseEvent) {
        event.stopPropagation()
        setShowInfoPopup(true)
    }

    if (!tariffs?.length) {
        return null
    }

    return (
        <>
            <div className="upgradesSection proSubscriptionSection">
                <h2 className="H3_21_v2">Подписка Pro</h2>
                <div className="pro-subscription-section__subtitle">
                    Брендирование страницы подписания и расширенные возможности для команды.
                    Пакет документов в подписку не входит — его нужно оформить отдельно.
                    <InfoButton onClick={handleInfoClick} size="small" />
                </div>

                <div className="upgrades-grid-v2">
                    {tariffs.map((tariff) => {
                        const selected = isInCart(tariff._id)
                        const discount = tariff.discount || 0
                        const originalPrice = tariff.price || 0
                        const finalPrice = applyDiscountToPrice(originalPrice, discount)
                        const showDiscount = discount > 0 && originalPrice > 0
                        return (
                            <div
                                key={tariff._id}
                                className={`upgrade-card-v2 ${selected ? 'selected' : ''}`}
                                onClick={() => onAddToCart(tariff)}
                            >
                                <div className="upgrade-header">
                                    <div className="upgrade-name-row">
                                        <div className="upgrade-name">{periodLabel(tariff.period)}</div>
                                        {showDiscount && (
                                            <div className="discount-badge-inline">-{discount}%</div>
                                        )}
                                    </div>
                                    <div className="upgrade-icon">⭐</div>
                                </div>
                                <div className="upgrade-description">
                                    {periodHint(tariff.period)}
                                </div>
                                <div className={`upgrade-price${showDiscount ? ' upgrade-price--discounted' : ''}`}>
                                    {showDiscount && (
                                        <div className="original-price">{formatPriceRub(originalPrice)}</div>
                                    )}
                                    <div className={showDiscount ? 'discounted-price' : ''}>
                                        {formatPriceRub(finalPrice)}
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>

            {showInfoPopup && (
                <ProSubscriptionInfoPopup onClose={() => setShowInfoPopup(false)} />
            )}
        </>
    )
}

export default ProSubscriptionSection
